import React, { memo } from 'react';

const scroll_down = {
    margin: 'auto',
    width: 'var(--scale-5xl)',
    height: 'var(--scale-10xl)'
}
const scroll_down_mousey = {
    width: 'var(--scale-ess)',
    padding: '8px 12px',
    height: 'var(--scale-6xl)',
    border: '2px solid var(--border-strong)',
    borderRadius: 'var(--scale-3xl)',
    opacity: '0.75',
    boxSizing: 'content-box'
}
const scroll_down_mousey_scroller = {
    width: 'var(--scale-sm)',
    height: 'var(--scale-md)',
    borderRadius: '25%',
    backgroundColor: 'var(--border-strong)',
    animationName: 'scroll',
    animationDuration: '2.2s',
    animationTimingFunction: 'cubic-bezier(.15, .41, .69, .94)',
    animationIterationCount: 'infinite'
}

export const ScrollDownAnimation = memo(() => {
  return (
    <div style={{ ...scroll_down }}>
      <div style={{ ...scroll_down_mousey }}>
        <div style={{ ...scroll_down_mousey_scroller }}></div>
      </div>
    </div>
  )
});
